import { Component, Input, OnInit } from '@angular/core';
import { isUndefined, onlyAphaNumeric, spaceToHyphen } from 'src/app/services/codeUtils';
import { ConfigService } from 'src/app/services/config/config.service';
import { GameHubControllerService } from 'src/app/services/gameHub/game-hub-controller';
import { GamesService } from 'src/app/services/lobby/games.service';
import { LobbyService } from 'src/app/services/lobby/lobby.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { WebcontentService } from 'src/app/services/webcontent/webcontent.service';
import { Navigator } from '../../menu/navigator';
import { LobbyStateService } from 'src/app/services/lobbyState/lobby-state.service';
import { LobbyNavigator } from 'src/app/services/lobby/lobby-navigator.service';

@Component({
  selector: 'app-ld-game-tile',
  templateUrl: './ld-game-tile.component.html',
  styleUrls: ['./ld-game-tile.component.scss'],
})
export class LiveDealerGameTileComponent implements OnInit {

  @Input() logoutLobbyTiles: any

  public imagesPath: string;
  public isAuthenticated: boolean = false;

  constructor(
    private readonly gameHubControllerService: GameHubControllerService,
    private readonly gamesService: GamesService,
    public configService: ConfigService,
    public lobbyService: LobbyService,
    public navigator: Navigator,
    private lobbyState: LobbyStateService,
    public userSessionService: UserSessionService,
    private lobbyNavigator: LobbyNavigator,
    public webcontentService: WebcontentService,
  ){

  }

  ngOnInit(): void {
    this.imagesPath = this.lobbyService.galleryImagePath;
    this.verifyAuth();
  }

  public verifyAuth(){
    this.userSessionService.isAuthenticated().then((res) => {
      if(res) this.isAuthenticated = true;
    });
  }

  public onInfo(gamedata: any) {
    let wpLink: string = this.getWPPageStub(gamedata.game_name);
    const matchedLink: any = this.checkForExternalLinks(wpLink);
    this.updateWpContent(matchedLink, wpLink);
    //this.navigator.toWebview();
    this.navigator.toGameInfoTab(false, wpLink);
    this.lobbyService.setWaitingGameData(gamedata);
    /*return setTimeout(
      () => this.navigator.pushHistoryState("game/" + wpLink),
      1000
    );*/
  }

  public onLogin(gameData: any){
    if (gameData.super_type === "LIVE_DEALER") {
      localStorage.setItem('skipActiveBonusCheck', 'true');
    }
    return this.goToLogin(gameData);
  }

  private goToLogin(gameData) {
    let subCategoryData;
    this.lobbyState.getCurrentKeywordSubject().subscribe(res => {
      //console.log(res)
      if (res && res.subKeywordsInfo?.length > 0) {
        //console.log(res?.keyword);
        this.lobbyService.setLiveDealerKeywordName(res?.keyword);
        //console.log(res?.subKeywordsInfo)
        subCategoryData = res?.subKeywordsInfo.filter(entry => {
          const actionParam = JSON.parse(entry.action_param);
          return actionParam.vendor === gameData.vendor_name;
        });
        //console.log(subCategoryData);
        this.lobbyNavigator.setCurrentTab('livedealer');
        this.lobbyService.setWaitingGameData(subCategoryData);
      } else {
       //console.log(res?.keyword);
        this.lobbyService.setLiveDealerKeywordName(res?.keyword);
        subCategoryData = gameData;
        this.lobbyNavigator.setCurrentTab('livedealer');
        this.lobbyService.setWaitingGameData(subCategoryData);
      }
    }).unsubscribe();
    //console.log(gameData)
    return this.navigator.navigateTo("LoginComponent");
  }

  public checkForExternalLinks(url: string): any {
    const externalLinks = this.configService.getExternalLinks().payload;
    const filteredExternalLink = externalLinks.filter(
      (link) => link.url == url
    )[0];
    return filteredExternalLink;
  }

  public getWPPageStub(name: string): string {
    const onlyAlphaNumeric = onlyAphaNumeric(name);
    const lowerCaseName = onlyAlphaNumeric.toLowerCase();
    const urlStub = spaceToHyphen(lowerCaseName);
    return urlStub;
  }

  public updateWpContent(link: any, page: string): any {
    const gameInfoErrorPage = this.configService.getConfig().WP_GAME_INFO_ERROR_PAGE ?? "gameinfo_default";
    if (isUndefined(link) && !link) return this.webcontentService.updateExternalLink(gameInfoErrorPage);
    return this.webcontentService.updateExternalLink(page);
  }

  public isFavourite(game_id) {
    if (!this.isAuthenticated) return false;
    return this.gamesService.isFavourite(game_id);
  }

  public makeFavourite(gamedata, event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.gamesService.addFavouritesAndRecreate(gamedata);
    return;
  }

  makeUnFavourite(game_id, event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.gamesService.removeFavouritesAndRecreate(game_id);
    return;
  }

}
